import { useVaultsPriceHistory, } from "./useVaultPerformanceUpdate";
import { VaultList, getVaultChain, } from "../constants/constants";
import useVaultActivity from "./useVaultActivity";
import { useMemo, useState } from "react";
import bn from "bignumber.js";
import { formatOptionAmount, formatBigNumber } from "../utils/math";
export var useBonsaiAPR_v1 = function () {
    var _a = useVaultsPriceHistory(), vaultsPriceHistory = _a.data, vaultsPriceHistoryLoading = _a.loading;
    var loading = vaultsPriceHistoryLoading;
    var bonsaiAPRDependOn = [vaultsPriceHistory, loading];
    var bonsaiAPR = useMemo(function () {
        var version = "v2";
        var bonsaiAPR = {};
        VaultList.map(function (vaultName) {
            var pricePerShareHistory = vaultsPriceHistory[version][vaultName];
            if (pricePerShareHistory == undefined || pricePerShareHistory.length == 0) {
                bonsaiAPR[vaultName] = undefined;
            }
            else {
                var lastPPS = new bn(pricePerShareHistory[pricePerShareHistory.length - 1].pricePerShare.toHexString());
                var firstPPS = new bn(pricePerShareHistory.length > 52 ? pricePerShareHistory[pricePerShareHistory.length - 53].pricePerShare.toHexString() : pricePerShareHistory[0].pricePerShare.toHexString());
                // console.group("APR")
                // console.log(lastPPS)
                // console.log(firstPPS)
                // console.log(lastPPS.div(firstPPS))
                // console.log(lastPPS.div(firstPPS).minus(1))
                // console.log(lastPPS.div(firstPPS).minus(1).times(365))
                // console.log(lastPPS.div(firstPPS).minus(1).times(365).div(pricePerShareHistory.length > 52 ? 52 : pricePerShareHistory.length - 1))
                // console.log(lastPPS.div(firstPPS).minus(1).times(365).div(pricePerShareHistory.length > 52 ? 52 : pricePerShareHistory.length - 1).div(7))
                // console.groupEnd()
                if (pricePerShareHistory.length == 1) {
                    bonsaiAPR[vaultName] = new bn(0);
                }
                else {
                    bonsaiAPR[vaultName] = lastPPS.div(firstPPS).minus(1).times(365).div(pricePerShareHistory.length > 52 ? 52 : pricePerShareHistory.length - 1).div(7);
                }
            }
        });
        // console.group('vaultsPriceHistory')
        // console.log(vaultsPriceHistory)
        // console.log(bonsaiAPR)
        // console.groupEnd()
        return bonsaiAPR;
    }, bonsaiAPRDependOn);
    return { fetched: !loading, res: bonsaiAPR };
};
export var useBonsaiAPR = function () {
    var version = "v2";
    var _a = useState(0), fetchedNum = _a[0], setFetchedNum = _a[1];
    var _b = useState({}), bonsaiAPRData = _b[0], setData = _b[1];
    var items = [];
    VaultList.map(function (vaultName) {
        var chain = getVaultChain(vaultName);
        var _a = useVaultActivity(vaultName, version), activities = _a.activities, loading = _a.loading;
        var bonsaiAPRDependOn = [activities, loading];
        var bonsaiAPRItem = useMemo(function () {
            // console.log("activities:")
            // console.log(activities)
            var selected = undefined;
            for (var i = 0; i < activities.length; i++) {
                var item = activities[i];
                if (item.type == "sales") {
                    if (selected == undefined || selected.timestamp < item.timestamp) {
                        selected = item;
                    }
                }
            }
            if (selected == undefined) {
                return new bn(0);
            }
            else {
                var sellAmount = new bn(formatOptionAmount(selected.sellAmount, chain));
                var premium = new bn(formatBigNumber(selected.premium));
                var apy = premium.div(sellAmount).div(7).times(365);
                var newData = Object.assign({}, bonsaiAPRData); // bonsaiAPRData[vaultName] = apy
                newData[vaultName] = apy;
                setData(newData);
                setFetchedNum(fetchedNum + 1);
                return apy;
            }
        }, bonsaiAPRDependOn);
        items.push(bonsaiAPRItem);
    });
    var fetched = useMemo(function () {
        // console.group('comin fetched')
        // console.log(fetchedNum >= VaultList.length)
        // console.log(fetchedNum)
        // console.log(VaultList.length)
        // console.groupEnd()
        return fetchedNum >= VaultList.length;
    }, [fetchedNum]);
    return { fetched: fetched, res: bonsaiAPRData, fetchedNum: fetchedNum };
};
//# sourceMappingURL=useBonsaiAPR.js.map